// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface TransformationsOptions {
    width?: number | string;
    height?: number | string;
    quality?: "best" | "good" | "eco" | "low";
    transform?: string;
}

/**
 *
 * @param url: image url
 * @param baseUrl: Bynder url domain - include slash at the end
 * @param transformations: image transformation
 */
export const getBynderUrl = (
    url?: string,
    baseUrl?: string,
    transformations?: TransformationsOptions,
): string => {
    let options = "?io=";

    // if the url doesn't Bynder or empty - send back
    if (!url || !baseUrl || !url.startsWith(baseUrl)) {
        return url || "";
    }

    const imageUrlPath = url.replace(baseUrl, "");

    // If this is a svg file, we need to remove f_auto option which will
    // rasterizer the vector graphic and instead use fl_sanitize to prevent
    // automatically downloading the svg instead of displaying correctly as img src.
    if (url.endsWith(".svg")) {
        options = "";
    } else {
        options = `?io=`;

        if(transformations) {
            Object.keys(transformations || {}).forEach(key => {
                options += `${key}:${(transformations as any)[key]},`;
            });

            // removing last ,
            options = options.substring(0, options.length - 1);
        }
        
    }

    return `${baseUrl}${imageUrlPath}${options}`;
};
